import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { useIntl } from 'react-intl'

function FlexibleCancellationCharterFlightFees() {
  const intl = useIntl()
  return <BodyText variant="medium" as="span">
    <b>{intl.formatMessage({
      id: '1I7bQqZ/GC',
      defaultMessage: 'Date changes',
      description: 'Heading for date changes section in charter flight cancellation fees',
    })}
    </b>
    <br />
    {intl.formatMessage({
      id: '2LHBDhP77x',
      defaultMessage: 'One change permitted up to 21 days prior to departure. Subject to availability and a change fee.',
      description: 'Policy text about date change permissions for charter flights',
    })}
    <ul>
      <li>
        {intl.formatMessage({
          id: 'vAjjyPXZFt',
          defaultMessage: 'Economy: $200 change fee per person',
          description: 'Economy class date change fee for charter flights',
        })}
      </li>
      <li>
        {intl.formatMessage({
          id: 'AqaNfyWPed',
          defaultMessage: 'Business: $500 change fee per person',
          description: 'Business class date change fee for charter flights',
        })}
      </li>
    </ul>
    {intl.formatMessage({
      id: 'oy+6v5ej4I',
      defaultMessage: 'Additional change fees may apply for peak periods or property-specific surcharges.',
      description: 'Additional change fee disclaimer for charter flights',
    })}
    <br />
    <br />
    <b>{intl.formatMessage({
      id: 'hfGUkW472B',
      defaultMessage: 'Cancellations',
      description: 'Heading for cancellations section in charter flight cancellation fees',
    })}
    </b>
    <br />
    {intl.formatMessage({
      id: 'OKPcfkdAsq',
      defaultMessage: 'Cancellations made during this period will incur the following fees:',
      description: 'Introduction to cancellation fees list for charter flights',
    })}
    <ul>
      <li>
        {intl.formatMessage({
          id: 'p4gggGC96T',
          defaultMessage: 'Economy: $995 per person',
          description: 'Economy class cancellation fee for charter flights',
        })}
      </li>
      <li>
        {intl.formatMessage({
          id: 'tBIa7unhMn',
          defaultMessage: 'Business: $2,995 per person',
          description: 'Business class cancellation fee for charter flights',
        })}
      </li>
    </ul>
    {intl.formatMessage({
      id: 'mi+dNXTPVM',
      defaultMessage: 'The remaining balance, after deduction of the applicable cancellation fees, will be refunded to your original payment or credit.',
      description: 'Refund information after cancellation fee deduction for charter flights',
    })}
  </BodyText>
}

export default FlexibleCancellationCharterFlightFees
